import { FC } from 'react';

import { TOAuthButtonsTexts } from '../../types';

import styles from './Widgets.module.scss';
import { useAdaptive } from '../../hooks';
import { TextBlock } from '../../components';
import { ButtonOAuth } from '../../components/buttons/ButtonOAuth';

const env = (
  import.meta as unknown as { env: Record<string, string | undefined> }
).env;

function isOAuthEnabled(value: string | undefined): boolean {
  return value === 'true';
}

const socials = [
  { name: 'google', enabled: isOAuthEnabled(env.VITE_IS_GOOGLE_OAUTH_ENABLED) },
  {
    name: 'discord',
    enabled: isOAuthEnabled(env.VITE_IS_DISCORD_OAUTH_ENABLED),
  },
  {
    name: 'facebook',
    enabled: isOAuthEnabled(env.VITE_IS_FACEBOOK_OAUTH_ENABLED),
  },
] as const;

export const OAuthButtons: FC<{
  isRegister?: boolean;
  texts: TOAuthButtonsTexts;
}> = ({ isRegister, texts }) => {
  const { isMobile } = useAdaptive();
  const enabledSocials = socials.filter((social) => social.enabled);

  if (!enabledSocials.length) return null;

  return (
    <div className={styles.oauthContainer}>
      <div className={styles.oauthButtons}>
        {enabledSocials.map(({ name }) => {
          const social = texts.socials[name];
          const socialLong = isRegister
            ? texts.signUpWith.replace('{{social}}', social)
            : texts.signInWith.replace('{{social}}', social);
          const text =
            isMobile || enabledSocials.length > 1 ? social : socialLong;

          return (
            <ButtonOAuth
              icon={`logo-${name}`}
              key={name}
              style={{ flex: `1 1 ${100 / enabledSocials.length}%` }}
              text={text}
              url={`/api/oauth/${name}`}
            />
          );
        })}
      </div>

      <div className={styles.oauthHr}>
        <TextBlock
          className={styles.oauthHr__text}
          color="secondary"
          line="100"
        >
          {texts.or}
        </TextBlock>
      </div>
    </div>
  );
};
